
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adstod",
      function () {
        return require("private-next-pages/adstod/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adstod"])
      });
    }
  